import { render, staticRenderFns } from "./supplierbox.vue?vue&type=template&id=6d41301c&scoped=true&"
import script from "./supplierbox.vue?vue&type=script&lang=js&"
export * from "./supplierbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41301c",
  null
  
)

export default component.exports